import { ColumnConfig } from '@/components/table/Table';
import { AssetStatus, AssetStatusLabels } from '../enum';
import { AssetApi } from '../models';

export const assetsTableColumns: ColumnConfig[] = [
  { 
    label: 'Tipo', 
    field: 'assetType',
    render: (value: unknown, row: AssetApi) => {
      const assetType = value as { name: string } | null;
      if (assetType?.name) return assetType.name;
      if (row.typeId) return `Tipo ID: ${row.typeId.slice(0, 8)}...`;
      return '______';
    },
  },
  { 
    label: 'Marca', 
    field: 'brand', 
    sortable: true,
    render: (value: unknown, row: AssetApi) => {
      const brand = value as { name: string } | null;
      if (brand?.name) return brand.name;
      if (row.brandId) return `Marca ID: ${row.brandId.slice(0, 8)}...`;
      return '______';
    },
  },
  { 
    label: 'Modelo', 
    field: 'model', 
    sortable: true,
    render: (value: unknown, row: AssetApi) => {
      const model = value as { name: string } | null;
      if (model?.name) return model.name;
      if (row.modelId) return `Modelo ID: ${row.modelId.slice(0, 8)}...`;
      return '______';
    },
  },
  { 
    label: 'Número de Serie', 
    field: 'serialNumber',
    render: (value: string) => value || '______',
  },
  { 
    label: 'Código de Barras', 
    field: 'barcode',
    render: (value: string | null) => value || 'Sin código',
  },
  { 
    label: 'Fecha de Compra', 
    field: 'purchaseDate',
    render: (value: string) => value || '______',
  },
  { 
    label: 'Fecha de Garantia', 
    field: 'warrantyDate',
    render: (value: string | null) => value || 'Sin garantia',
  },
  {
    label: 'Estado',
    field: 'status',
    render: (value: string) =>
      (AssetStatusLabels[value as AssetStatus] ?? value) || '______',
  },
  { 
    label: 'Condicion', 
    field: 'condition',
    render: (value: string) => value || '______',
  },
  { 
    label: 'Observaciones', 
    field: 'note', 
    render: (value: string) => value || '______',
  },
  {
    label: 'Oficina',
    field: 'office',
    render: (value: { name: string } | null) => {
      if (!value) return '______';
      return value.name || '______';
    },
  },
  {
    label: 'Usuario actual',
    field: 'user',
    render: (value: { fullName: string } | null) => value?.fullName || '______',
  },
  { 
    label: 'Accesorios', 
    field: 'accesory', 
    render: (value: string) => value || '______',
  },
  {
    label: 'Costo (USD)',
    field: 'cost',
    render: (value: number) => value !== undefined && value !== null ? `USD ${Number(value).toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '______',
    sortable: true,
  },
];
